import { render, staticRenderFns } from "./TrackingNumbers.vue?vue&type=template&id=6630c432&"
import script from "./TrackingNumbers.vue?vue&type=script&lang=js&"
export * from "./TrackingNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TrackingNumbers.vue"
export default component.exports